export const M2_UNIT_16 = {
  id: "m2-u16",
  title: "Unit 16: Measurements",
  topic: "Cooking & Quantities",
  iconType: "shopping", // Relacionado con compras y comida
  grammarImage: "/m2-u16-grammar.jpg", // Sube esta imagen a public
  grammarText: "Vocabulario de medidas: Liters (líquidos), Grams/Kilograms (peso), Cups/Spoons (cocina).",
  sets: [
    {
      id: "u32-set1",
      title: "Set 1: Measurements - Basic Units",
      questions: [
        { type: "mc", q: "Liquid volume = ___", options: ["liter", "gram", "teaspoon"], a: "liter" },
        { type: "mc", q: "Weight = kilogram or ___", options: ["gram", "cup", "slice"], a: "gram" },
        { type: "blank", q: "Recipe: 2 ___ flour. (cups)", options: ["cups"], a: "cups" },
        { type: "mc", q: "Small spoon = ___", options: ["teaspoon", "tablespoon", "liter"], a: "teaspoon" },
        { type: "blank", q: "Big spoon = ___ (tablespoon).", options: ["tablespoon"], a: "tablespoon" },
        { type: "order", q: "Ordena: 500 grams cheese", words: ["500", "grams", "cheese"], a: "500 grams cheese" },
        { type: "mc", q: "'1 liter water' correct. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Cooking measure: cup, spoon, knife.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "1 ___ sugar. (kilogram)", options: ["kilogram"], a: "kilogram" },
        { type: "order", q: "Ordena: 2 liters milk", words: ["2", "liters", "milk"], a: "2 liters milk" }
      ]
    },
    {
      id: "u32-set2",
      title: "Set 2: Ingredients with Quantities",
      questions: [
        { type: "mc", q: "Flour: cups, grams, ___", options: ["kilograms", "liters"], a: "kilograms" },
        { type: "mc", q: "Salt: teaspoon, tablespoon, ___", options: ["pinch", "liter"], a: "pinch" },
        { type: "blank", q: "Sugar: 250 ___ (grams).", options: ["grams"], a: "grams" },
        { type: "mc", q: "Liquid: 1 liter, 500 ml, cup.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Oil: 2 ___ (tablespoons).", options: ["tablespoons"], a: "tablespoons" },
        { type: "order", q: "Ordena: 1 teaspoon salt", words: ["1", "teaspoon", "salt"], a: "1 teaspoon salt" },
        { type: "mc", q: "Recipe uses precise amounts. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "Butter: 100 grams or 1 stick.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Pepper: ___ of pepper (pinch).", options: ["pinch"], a: "pinch" },
        { type: "order", q: "Ordena: 3 cups water", words: ["3", "cups", "water"], a: "3 cups water" }
      ]
    },
    {
      id: "u32-set3",
      title: "Set 3: Talking About Amounts",
      questions: [
        { type: "mc", q: "How much water? 2 ___", options: ["liters", "grams"], a: "liters" },
        { type: "mc", q: "How much flour? 500 ___", options: ["grams", "liters"], a: "grams" },
        { type: "blank", q: "Recipe needs 2 ___ sugar. (cups)", options: ["cups"], a: "cups" },
        { type: "mc", q: "Small amount salt: 1 ", options: ["teaspoon", "liter"], a: "teaspoon" },
        { type: "blank", q: "Vinegar: 1 ___ (tablespoon).", options: ["tablespoon"], a: "tablespoon" },
        { type: "order", q: "Ordena: half a liter milk", words: ["half", "a", "liter", "milk"], a: "half a liter milk" },
        { type: "mc", q: "'250g cheese' weight measure. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "1.5 liters soup liquid.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "A ___ of salt. (pinch)", options: ["pinch"], a: "pinch" },
        { type: "order", q: "Ordena: quarter cup oil", words: ["quarter", "cup", "oil"], a: "quarter cup oil" }
      ]
    },
    {
      id: "u32-set4",
      title: "Set 4: Recipe Comprehension",
      questions: [
        { type: "mc", q: "Cake: 2 cups flour, 1 cup sugar, 3 eggs. Correct?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Soup: 1 ___ water + carrots. (liter)", options: ["liter"], a: "liter" },
        { type: "mc", q: "Pasta: 500g pasta, 2 tablespoons oil.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Salad dressing: 1 ___ vinegar. (tablespoon)", options: ["tablespoon"], a: "tablespoon" },
        { type: "mc", q: "Bread: 500g flour, 1 teaspoon salt, yeast.", options: ["True", "False"], a: "True" },
        { type: "order", q: "Recipe: pancake ingredients", words: ["1", "cup", "flour,", "1", "egg,", "1", "cup", "milk"], a: "1 cup flour, 1 egg, 1 cup milk" },
        { type: "mc", "q": "Omelette: 3 eggs, pinch salt. True?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "Cookies: 200g butter, 1 cup ___ (sugar).", options: ["sugar"], a: "sugar" },
        { type: "mc", "q": "Rice: 2 cups rice, 4 cups water. Correct ratio?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Chocolate cake: flour, cocoa, sugar, eggs.", words: ["2", "cups", "flour,", "half", "cup", "cocoa,", "1", "cup", "sugar"], a: "2 cups flour, half cup cocoa, 1 cup sugar" }
      ]
    },
    {
      id: "u32-set5",
      title: "Set 5: Shopping Quantities",
      questions: [
        { type: "mc", q: "I need 1 ___ bread. (loaf)", options: ["loaf", "slice"], a: "loaf" },
        { type: "blank", q: "500 ___ cheese. (grams)", options: ["grams"], a: "grams" },
        { type: "mc", q: "2 ___ milk. (liters)", options: ["liters", "grams"], a: "liters" },
        { type: "blank", q: "Jar of ___ (jam).", options: ["jam"], a: "jam" },
        { type: "mc", "q": "Bag of sugar, pack of butter. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Ordena shopping list", words: ["1", "liter", "milk,", "500g", "flour,", "2", "eggs"], a: "1 liter milk, 500g flour, 2 eggs" },
        { type: "mc", "q": "Can of tuna correct. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "3 ___ apples. (bags)", options: ["bags"], a: "bags" },
        { type: "mc", "q": "1 kg potatoes weight. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Ordena: dozen eggs", words: ["dozen", "eggs"], a: "dozen eggs" }
      ]
    },
    {
      id: "u32-set6",
      title: "Set 6: Error Correction",
      questions: [
        { type: "mc", q: "2 liter milk. (Fix)", options: ["2 liters milk", "2 liter of milk"], a: "2 liters milk" },
        { type: "blank", q: "500 gram cheese → 500 ___ cheese.", options: ["grams"], a: "grams" },
        { type: "mc", q: "1 cup flours wrong plural. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Corrige: teaspoon salts", words: ["teaspoon", "salt"], a: "teaspoon salt" },
        { type: "blank", "q": "2 tablespoon oil → 2 ___ oil.", options: ["tablespoons"], a: "tablespoons" },
        { type: "mc", q: "'Half kilogram butter' correct. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "1 slice breads wrong. Fix?", options: ["1 slice bread", "1 slices bread"], a: "1 slice bread" },
        { type: "blank", "q": "3 cup sugar → 3 ___ sugar.", options: ["cups"], a: "cups" },
        { type: "order", q: "Corrige: pinch peppers", words: ["pinch", "of", "pepper"], a: "pinch of pepper" },
        { type: "mc", "q": "1.5 liter water correct. True?", options: ["True", "False"], a: "True" }
      ]
    },
    {
      id: "u32-set7",
      title: "Set 7: Mixed Measurements",
      questions: [
        // Convertido a MC para soportar 3 respuestas
        { type: "mc", q: "___ grams flour / ___ liters soup / ___ teaspoons salt.", options: ["500 / 2 / 2", "200 / 1 / 1"], a: "500 / 2 / 2" },
        { type: "mc", q: "Weight: gram/kg Volume: liter/ml Spoon: teaspoon", options: ["True", "False"], a: "True" },
        // Convertido a MC
        { type: "mc", q: "Cake: 2 ___ flour, 250 ___ butter.", options: ["cups / grams", "liters / cups"], a: "cups / grams" },
        { type: "mc", q: "Soup: 1.5 liters water + vegetables. True?", options: ["True", "False"], a: "True" },
        // Convertido a MC
        { type: "mc", q: "Cookies: 100 ___ sugar, 1 ___ vanilla.", options: ["grams / teaspoon", "kg / cup"], a: "grams / teaspoon" },
        { type: "order", q: "Mix: 2 cups milk + 500g cheese + pinch salt.", words: ["2", "cups", "milk,", "500g", "cheese,", "pinch", "salt"], a: "2 cups milk, 500g cheese, pinch salt" },
        { type: "mc", "q": "Pasta: 2 tablespoons oil correct. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Bread: 1 kg ___ + yeast.", options: ["flour"], a: "flour" },
        { type: "mc", "q": "Salad: 1 tablespoon vinegar per person. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Omelette: 3 eggs + pinch salt + 1 tablespoon oil.", words: ["3", "eggs,", "pinch", "salt,", "1", "tablespoon", "oil"], a: "3 eggs, pinch salt, 1 tablespoon oil" }
      ]
    },
    {
      id: "u32-set8",
      title: "Set 8: Shopping Dialogue",
      questions: [
        { type: "mc", q: "I need 500 ___ flour.", options: ["grams", "liters"], a: "grams" },
        { type: "blank", q: "2 ___ milk, please. (liters)", options: ["liters"], a: "liters" },
        { type: "mc", q: "Do you have 1 kg potatoes?", options: ["True question", "False"], a: "True question" },
        { type: "blank", q: "Jar of ___ jam. (strawberry)", options: ["strawberry"], a: "strawberry" },
        { type: "mc", "q": "Loaf of bread, please. Correct?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Dialogue: How much rice? 1 kg rice.", words: ["1", "kg", "rice"], a: "1 kg rice" },
        { type: "mc", "q": "Dozen eggs correct quantity. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Pack of ___ butter.", options: ["butter"], a: "butter" },
        { type: "mc", "q": "2 bottles soda correct. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Complete order: 500g cheese, 2 liters milk.", words: ["500g", "cheese,", "2", "liters", "milk"], a: "500g cheese, 2 liters milk" }
      ]
    },
    {
      id: "u32-set9",
      title: "Set 9: Advanced Recipes",
      questions: [
        { type: "blank", q: "Chocolate cake: 200g ___ + 100g cocoa. (butter)", options: ["butter"], a: "butter" },
        { type: "mc", q: "Lasagna: 500g pasta sheets, 1 liter béchamel, 400g cheese.", options: ["True quantities", "False"], a: "True quantities" },
        { type: "blank", q: "Stir fry: 2 ___ oil + 300g vegetables. (tablespoons)", options: ["tablespoons"], a: "tablespoons" },
        { type: "mc", q: "Sushi rice: 2 cups rice + 500 ml water + 4 tablespoons vinegar.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Pizza dough: 500g flour + 300 ___ water.", options: ["ml"], a: "ml" },
        { type: "order", q: "Thanksgiving turkey: 5kg turkey + stuffing + vegetables.", words: ["5kg", "turkey,", "stuffing,", "vegetables"], a: "5kg turkey, stuffing, vegetables" },
        { type: "mc", "q": "French onion soup: 1.5 kg onions + 2 liters stock. True?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "Pad Thai: 200g rice noodles + 2 ___ fish sauce.", options: ["tablespoons"], a: "tablespoons" },
        { type: "mc", "q": "All measurements precise for recipes. True?", options: ["True"], a: "True" },
        { type: "order", q: "Paella: 400g rice + 1.5 liters stock + seafood.", words: ["400g", "rice,", "1.5", "liters", "stock,", "seafood"], a: "400g rice, 1.5 liters stock, seafood" }
      ]
    },
    {
      id: "u32-set10",
      title: "Set 10: Full Measurement Challenge",
      questions: [
        { type: "mc", "q": "Complete: grams flour / liters soup / teaspoons salt / cups sugar. All?", options: ["True"], a: "True" },
        // Convertido a MC porque era un Blank de "True"
        { type: "mc", "q": "Shopping: 1kg potatoes / 2L milk / 500g cheese / 3 dozen eggs.", options: ["True", "False"], a: "True" },
        { type: "order", q: "Master recipe: cake with precise amounts.", words: ["2", "cups", "flour,", "250g", "butter,", "3", "eggs,", "1", "cup", "milk"], a: "2 cups flour, 250g butter, 3 eggs, 1 cup milk" },
        { type: "mc", "q": "Quick: 1 tablespoon = small spoon. False, big spoon!", options: ["False"], a: "False" },
        // Convertido a MC
        { type: "mc", "q": "Recipe conversions: 250ml = quarter liter / 500g = half kilogram.", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "'2 kilogram apples' wrong plural. True?", options: ["True"], a: "True" },
        { type: "order", q: "Challenge: international recipe measurements.", words: ["500g", "flour", "(US/UK)", "500ml", "water", "(metric)", "2", "teaspoons", "baking", "powder"], a: "500g flour (US/UK), 500ml water (metric), 2 teaspoons baking powder" },
        // Convertido a MC
        { type: "mc", "q": "Pinch salt = very small amount. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "All correct: liters liquid / grams solids / teaspoons spices. True?", options: ["True"], a: "True" },
        { type: "order", q: "Ultimate: complete cooking instructions with measurements.", words: ["Mix", "2", "cups", "flour", "+", "1", "teaspoon", "salt.", "Add", "1", "liter", "water", "slowly."], a: "Mix 2 cups flour + 1 teaspoon salt. Add 1 liter water slowly." }
      ]
    }
  ]
};
